import { AriaTabPanel, VStack } from "@kazaar-platform/design-system";
import { type DesignProofsTabProps } from "./DesignProofsTab.types";
import { GraphismBloc } from "./GraphismBloc";
import { ProofBloc } from "./ProofBloc";

export const DesignProofsTab = ({
  orderItem,
  onTabNavigation,
}: DesignProofsTabProps) => {
  if (!orderItem) {
    return null;
  }

  return (
    <AriaTabPanel id="design_proofs" style={{ flex: 1 }}>
      <VStack gap="sp-xl">
        <GraphismBloc orderItem={orderItem} onTabNavigation={onTabNavigation} />
        <ProofBloc
          orderItem={orderItem}
          sandboxItemProof={orderItem?.sandboxItem?.sandboxItemProof}
        />
      </VStack>
    </AriaTabPanel>
  );
};
